import { EnhancedRadioGroup, IEnhancedRadioGroup } from "./EnhancedRadioGroup";
import React, { FC } from "react";

import { useController } from "react-hook-form";

// import { IEnhancedRadioGroup } from "@websential/cosmic-v20";


export interface IEnhancedRadioGroupRHF
	extends Pick<
		IEnhancedRadioGroup,
		// Exclude<keyof IEnhancedRadioGroup, "onChangeHandler">
		Exclude<keyof IEnhancedRadioGroup, "onChangeHandle">
	> {
	selectedValue?: string | boolean | number;
}

/**
 * RadioGroup is a helpful wrapper used to group Radio.
 * The EnhancedRadioGroup using the component EnhancedRadioButton.
 */
export const EnhancedRadioGroupRHF: FC<IEnhancedRadioGroupRHF> = ({
	name,
	selectedValue,
	disabled = false,
	readOnly = false,
	options,
	testId,
	displayAsRow = true,
	onChangeHandler
}) => {
	const {
		field: { onChange, value },
		formState: { errors },
	} = useController({
		name: name,
		defaultValue: selectedValue,
	});
	const onRadioButtonChange = (choosedItem: any) => {
		if (choosedItem) {
			onChange(choosedItem.target.value);
			if (onChangeHandler) {
				onChangeHandler(choosedItem);
			}
		} else {
			onChange(null);
			if (onChangeHandler) {
				onChangeHandler(null);
			}
		}
	};
	return (
		<EnhancedRadioGroup
			displayAsRow={displayAsRow}
			testId={testId}
			name={name}
			value={value}
			options={options}
			// onChangeHandler={onChange}
			onChangeHandler={(val) => onRadioButtonChange(val)}
			disabled={disabled}
			readOnly={readOnly}
			helperText={errors[name]?.message}
		/>
	);
};
